import { Grid, Stack, SxProps, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import AppButton, { IAppButtonProps } from "./app-button";
import LoadingScreen from "../loading-screen";
import { useSettingsContext } from "../settings/SettingsContext";

interface IAppContainerProps {
  children: ReactNode;
  // Optional props
  pageTitle?: string;
  //   routeLinks?: BreadcrumbsLinkProps[];
  isLoading?: boolean;
  sx?: SxProps;
  noContainer?: boolean;
  title?: string;

  buttons?: IAppButtonProps[];
}

export const AppContainer = ({
  pageTitle,
  //   routeLinks,
  children,
  isLoading,
  sx,
  noContainer,
  title,
  buttons,
}: IAppContainerProps) => {
  const settings = useSettingsContext();

  const view = (
    <>
      {(title || buttons) && (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">{title}</Typography>

          <Stack direction="row" spacing={1} alignItems="center">
            {buttons?.map((button, index) => (
              <AppButton key={index} fullWidth={false} {...button} />
            ))}
          </Stack>
        </Stack>
      )}
      {children}
    </>
  );

  if (isLoading) {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ height: { xs: "inherit", md: "75vh" }, ...sx }}
      >
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
        <LoadingScreen showImage={false} />
      </Grid>
    );
  }

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      {noContainer ? (
        view
      ) : (
        <Container maxWidth={settings.themeStretch ? false : "xl"} sx={{ mt: 2 }}>
          {view}
        </Container>
      )}
    </>
  );
};

export default AppContainer;
